import { Route } from "react-router-dom";
import { ForgotPassword } from "./routes/ForgotPassword";
import { SignIn } from "./routes/SignIn";
import { SignInToken } from "./routes/SignInToken";
import { SignUp } from "./routes/SignUp";
import { VerifyEmail } from "./routes/VerifyEmail";
import { VerifyPhone } from "./routes/VerifyPhone";

export const getAuthScene = () => {
  return (
    <Route path="auth">
      <Route path={`signin-token`} element={<SignInToken />} />

      <Route path={`signup`} element={<SignUp />} />

      <Route path={`verify/phone`} element={<VerifyPhone />} />

      <Route path={`verify/email`} element={<VerifyEmail />} />

      <Route path={`forgot-password`} element={<ForgotPassword />} />

      <Route path={`signin`} element={<SignIn />} />

      <Route index element={<SignIn />} />
    </Route>
  );
};
